import { useAuth } from "@dl/web-core-js/auth";
import { useMemo } from "react";
import { PartNoteClient, type PartNoteDTO } from "../../api/manufacturing";
import { NotesPanel, type NoteStore } from "../../components/NotesPanel";

/** The part's notes, with author and time (0063). */
export function PartNotesTab({ partId, editable }: { partId: number; editable: boolean }) {
  const { http } = useAuth();
  const store = useMemo((): NoteStore<PartNoteDTO> => {
    const client = new PartNoteClient(http);
    return {
      list: () => client.ofPart(partId),
      create: (body) => client.create({ id: 0, part_id: partId, body }),
      update: (note) => client.update(note),
      remove: (id) => client.remove(id),
    };
  }, [http, partId]);
  return <NotesPanel queryKey={["manufacturing", "part", partId, "notes"]} store={store} editable={editable} />;
}
